<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div>
    <div v-show="user_info.role == 'DEVELOPER' ">
        <p>Customer : {{customer_uuid}}</p>
        <p>Loan : {{selected_loan_uuid}}</p>
    </div>

    <vx-card title="Customer" class="mb-3">
        <template slot="actions">
            <!-- <feather-icon icon="PlusIcon" svgClasses="stroke-current text-primary w-4 h-4" class="ml-1" @click="addNewHere"/>  -->
            <vs-button size="small" color="warning" type="filled" @click="selectThis('new')">New Loan Account</vs-button>
        </template>
        <div class="vx-row mt-3" style="display: flex; flex-wrap: wrap;">
            <div class="vx-col image-container" style="flex: 0 0 auto; margin-bottom: 16px;">
                <vx-card class="attachments" v-if="picture_list.length > 0">
                    <div style="position:relative;" v-for="(item, index) in picture_list" :key="index">
                        <vs-button radius color="danger" style="position:absolute; top:0" @click="delete_image(item.id, index)" v-if="permissions_update || permissions_create" icon-pack="feather" icon="icon-trash-2"></vs-button>
                        <img :alt="item.filename" :title="item.filename" style="height: 220px; width:100%; cursor:pointer" :src="item.url" @click="view_image(item.url)">
                    </div>
                </vx-card>
                <vx-card v-else class="attachments" >
                    <vue-dropzone style="height: 220px; width:100%;" id="dropzone" ref="myVueDropzone" :use-custom-slot="true" :options="dropzoneOptions" @vdropzone-sending="sendingEvent" @vdropzone-complete="afterComplete">
                        <div class="dropzone-custom-content">
                            <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                            <h4>Drop files here or click to upload.</h4>
                        </div>
                    </vue-dropzone>
                </vx-card>
            </div>

            <div class="vx-col content-container" style="flex: 1 1 auto; margin-bottom: 16px;">
                <div style="display: flex; justify-content: space-between;">
                    <div class="btn-group arrows" style="margin-right: 3px;" v-if="$route.params.loan_id !== 'new'">
                        <vs-button @click="gotoLoan('previous', 'number')" class="button bt" color="dark" type="filled" icon-pack="feather" icon="icon-chevrons-left"></vs-button>
                        <vs-button @click="gotoLoan('previous', 'alphabet')" class="button bt" color="warning" type="filled" icon-pack="feather" icon="icon-chevron-left"></vs-button>
                    </div>

                    <vs-select class="w-full" placeholder="Search and select" label="Select customer" label-placeholder="Select customer" autocomplete v-model="customer_uuid">
                        <vs-select-item :key="item.uuid + '-' + index" :value="item.uuid" :text="(item.account_no ? item.account_no + ' - ' : '') + item.name + ' (' + item.status + ')'" v-for="(item, index) in customer_loans" />
                    </vs-select>

                    <div class="btn-group arrows" style="margin-left: 3px;" v-if="$route.params.loan_id !== 'new'">
                        <vs-button @click="gotoLoan('next', 'alphabet')" class="button bt" color="warning" type="filled" icon-pack="feather" icon="icon-chevron-right"></vs-button>
                        <vs-button @click="gotoLoan('next', 'number')" class="button bt" color="dark" type="filled" icon-pack="feather" icon="icon-chevrons-right"></vs-button>
                    </div>
                </div>

                <div class="vx-row mt-2" style="max-height: 255px;" v-if="unique_list_customer_loan.length > 0 && $route.params.loan_id !== 'new'">
                    <div class="vx-col" style="flex: 0 0 25%; border: 1px solid #000;">
                        <vs-list>
                            <!-- <vs-list-item class="py-4 cursor-pointer user-loan show-active" title="All"></vs-list-item> -->
                            <vs-list-item @click.native="chooseItem(item)" class="py-4 cursor-pointer user-loan" :key="index" v-for="(item, index) in unique_list_customer_loan" :title="item" :class="listSelect == item ? 'show-active' : ''"></vs-list-item>
                        </vs-list>
                    </div>

                    <div class="vx-col" style="flex: 1 1 75%; max-height: 255px; overflow-y: scroll; border: 1px solid #000;">
                        <vs-list class="box">
                            <vs-list-item :id="'id_' + item.account_no" @click.native="showThis(item)" class="py-4 cursor-pointer detail-loan" :key="index" v-for="(item, index) in displayList" :title="item.account_no" :class="selected_loan_uuid == item.uuid ? 'show-detail-active' : ''"></vs-list-item>
                        </vs-list>
                    </div>
                </div>
            </div>

            <div class="vx-col w-full lg:w-1/5 mb-2">
                <b>Contact List</b>
                <p v-show="customer_uuid == ''">No customer selected, please select customer first</p>
                <vs-collapse v-show="customer_uuid !== ''" type="border" accordion style="height: 300px; overflow-y: scroll;">
                    <vs-collapse-item :key="index" v-for="(item, index) in contact_lists_filter">
                        <div slot="header">
                            {{ item.name }} {{ index == 0 ? ' - (借主)' : '' }}
                        </div>
                        <p class="mt-2 mb-2"><small>Contact/联络号码: <a class="for-call" v-if="item.contact_no !== '' " :href="'tel:' + item.contact_no"><b>{{ item.contact_no }}</b></a> <span v-else>-</span></small></p>
                        <p class="mt-2 mb-2"><small>Address/地址: <b>{{ item.address !== '' ? item.address : '-' }}</b></small></p>
                        <p class="mt-2 mb-2"><small>Remark/备注: <b>{{ item.remark !== '' ? item.remark : '-' }}</b></small></p>
                    </vs-collapse-item>
                </vs-collapse>
            </div>
        </div>
    </vx-card>

    <vs-popup title="Loan Picture" :active.sync="flag_showImage" class="img-detail">
      <img style="max-width:100%" :src="viewed_image_url">
    </vs-popup>

    <div class="vx-row">
        <div class="vx-col lg:w-1/4 md:w-1/3 w-full mb-2">
            <!-- <vs-collapse accordion>
         <vs-collapse-item>
           <div slot="header">
            ONGOING
           </div>
           <vs-list>
            <vs-list-header title="Ongoing" color="warning" v-if="ongoing_list.length > 0"></vs-list-header>
              <vs-list-item class="cursor-pointer hover-warning" :class="item.uuid == selected_loan_uuid ? 'show-warning' : '' " :title="item.account_no" :subtitle="item.loan_date" v-for="item in ongoing_list" @click.native="selectThis(item.uuid)"></vs-list-item>
            </vs-list>
         </vs-collapse-item>
         <vs-collapse-item>
           <div slot="header">
             COMPLETED
           </div>
           <vs-list>
              <vs-list-header title="Complete" color="success" v-if="completed_list.length > 0"></vs-list-header>
                <vs-list-item class="cursor-pointer hover-success" :class="item.uuid == selected_loan_uuid ? 'show-success' : '' " :title="item.account_no" :subtitle="item.loan_date" v-for="item in completed_list" @click.native="selectThis(item.uuid)"></vs-list-item>
            </vs-list>
         </vs-collapse-item>
        </vs-collapse> -->
            <vx-card title="Customer Loan List" class="mb-2 mt-2">
                <template slot="actions">
                    <feather-icon icon="RefreshCwIcon" svgClasses="stroke-current text-primary w-4 h-4" class="ml-1" @click="refreshlist" />
                </template>
                <vs-list :class=" largeScreenWidth ? 'longlist' : 'shortlist' ">
                    <vs-list-header title="New"></vs-list-header>
                    <vs-list-item class="cursor-pointer hover-new" title="New Account" subtitle="create new loan" @click.native="selectThis('new')" :class="'new' == selected_loan_uuid ? 'show-new' : '' ">
                    </vs-list-item>
                    <vs-list-header title="Ongoing" color="warning" v-if="ongoing_list.length > 0"></vs-list-header>
                    <vs-list-item class="cursor-pointer hover-warning" :class="item.uuid == selected_loan_uuid ? 'show-warning' : '' " :title="item.account_no" :subtitle="item.loan_date" v-for="item in ongoing_list" @click.native="selectThis(item.uuid)"></vs-list-item>
                    <vs-list-header title="Complete" color="success" v-if="completed_list.length > 0"></vs-list-header>
                    <vs-list-item class="cursor-pointer hover-success" :class="item.uuid == selected_loan_uuid ? 'show-success' : '' " :title="item.account_no" :subtitle="item.loan_date" v-for="item in completed_list" @click.native="selectThis(item.uuid)"></vs-list-item>
                </vs-list>

            </vx-card>
            <!-- <h4 class="mb-2 mt-2">Customer Loan List</h4>
         <vs-list :class=" largeScreenWidth ? 'longlist' : 'shortlist' ">
          <vs-list-header title="New"></vs-list-header>
            <vs-list-item class="cursor-pointer hover-new" title="New Account" subtitle="create new loan" @click.native="selectThis('new')" :class="'new' == selected_loan_uuid ? 'show-new' : '' " >
            </vs-list-item>
          <vs-list-header title="Ongoing" color="warning" v-if="ongoing_list.length > 0"></vs-list-header>
            <vs-list-item class="cursor-pointer hover-warning" :class="item.uuid == selected_loan_uuid ? 'show-warning' : '' " :title="item.account_no" :subtitle="item.loan_date" v-for="item in ongoing_list" @click.native="selectThis(item.uuid)"></vs-list-item>
          <vs-list-header title="Complete" color="success" v-if="completed_list.length > 0"></vs-list-header>
            <vs-list-item class="cursor-pointer hover-success" :class="item.uuid == selected_loan_uuid ? 'show-success' : '' " :title="item.account_no" :subtitle="item.loan_date" v-for="item in completed_list" @click.native="selectThis(item.uuid)"></vs-list-item>
        </vs-list> -->
        </div>
        <div class="vx-col lg:w-3/4 md:w-2/3 w-full mb-2">
            <Detail v-on:updateLoan="refreshLoan" :loan_uuid='selected_loan_uuid' :customer_uuid="customer_uuid" />
            <!-- <Installment v-show="selected_loan_uuid !== 'new' " :loan_uuid='selected_loan_uuid'/> -->
            <InstallmentTable v-show="selected_loan_uuid !== 'new' " :loan_uuid='selected_loan_uuid' />
        </div>
    </div>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import imageCompressor from 'vue-image-compressor'
import Detail from './detail.vue'
import Installment from './loan_installment.vue'
import InstallmentTable from './installment_table.vue'

export default {
    name: 'Loan_Detail',
    props: {
        customerId: {
            type: String,
            default: '0'
        },
        isEdit: {
            type: Boolean,
            default: false
        },
    },
    components: {
        Datepicker,
        vueDropzone: vue2Dropzone,
        imageCompressor,
        Detail,
        Installment,
        InstallmentTable
    },
    data() {
        return {
            selected_loan_uuid: '',
            customer_uuid: '',
            contact_lists: [],
            customer_loan_list: [],
            flag_loading: false,
            listSelect: '',

            dropzoneOptions: {
                // url: "https://httpbin.org/post",
                url: process.env.VUE_APP_GLOBALURL + '/pictures',
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                maxThumbnailFilesize: 1,
                maxFilesize: 11,
                maxFiles: 6,
                parallelUploads: 1,
                autoDiscover: false,
                uploadMultiple: true,
                autoProcessQueue: true,
                // autoProcessQueue: true,
                acceptedFiles: ".jpeg,.jpg,.png,.gif",
                // forceFallback: true,
                headers: {
                    'Cache-Control': null,
                    'X-Requested-With': null,
                    Authorization: "Bearer " + sessionStorage.getItem('accessToken')
                },
                addRemoveLinks: true
            },
            picture_list: [],
            backup_loan_uuid: '',
            viewed_image_url: '',
            flag_showImage: false
        }
    },
    watch: {
        customer_uuid() {
            this.load_customer_loan_account(this.customer_uuid)

            //load customer contact
            this.load_customer_contact()
        },
        selected_loan_uuid() {
            this.backup_loan_uuid = this.selected_loan_uuid
            this.$router.replace(`/loan_detail/${this.selected_loan_uuid}`).catch(() => {})
        },
        currentLoanSelected(value) {
            if (value) {
                this.listSelect = value.substring(0, 3)
            }
        },
        backup_loan_uuid(){
          this.load_image(this.backup_loan_uuid)
        }
    },
    computed: {
        displayList() {
            return this.customer_loan_list.filter(item => {
                return (item.account_no).substring(0, 3) == this.listSelect
            })
        },
        currentLoanSelected() {
            let temp = this.customer_loan_list.filter(item => {
                return item.uuid == this.selected_loan_uuid
            })
            if (temp.length > 0) {
                return temp[0].account_no
            } else {
                return ''
            }
        },
        contact_lists_filter() {
            return this.contact_lists.filter(item => {
                return item.name !== ''
            })
        },
        unique_list_customer_loan() {
            let temp = []
            this.customer_loan_list.forEach(function (item) {
                var newItem = item.account_no.substring(0, 3)
                temp.indexOf(newItem) === -1 ? temp.push(newItem) : ''
            })

            return temp
        },
        ongoing_list() {
            let temp = []
            this.customer_loan_list.forEach(function (item) {
                if (item.loan_status == 'ACTIVE') {
                    temp.push(item)
                }
            })
            return temp
        },
        completed_list() {
            let temp = []
            this.customer_loan_list.forEach(function (item) {
                if (item.loan_status == 'COMPLETE') {
                    temp.push(item)
                }
            })
            return temp
        },
        permissions() {
            return this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions ?
                this.$store.state.AppActiveUser.permissions :
                [];
        },
        permissions_create() {
            return this.hasPermission('031');
        },
        permissions_list() {
            return this.hasPermission('032');
        },
        permissions_update() {
            return this.hasPermission('033');
        },
        permissions_delete() {
            return this.hasPermission('034');
        },
        largeScreenWidth() {
            if (window.innerWidth > 575) {
                return true
            } else
                return false
        },
        user_info() {
            let data = JSON.parse(sessionStorage.getItem('userInfo'));
            return data
        },
        users() {
            return this.$store.state.userManagement.users
        },
        loans() {
            return this.$store.state.userManagement.loans
        },
        customers() {
            return this.$store.state.customerManagement.customers
        },
        customer_loans() {
            let newArray = []
            
            // Safely process customers
            if (this.customers && Array.isArray(this.customers)) {
                this.customers.forEach(function (item) {
                    if (item && item.name && item.name.length > 5 && item.name !== '') {
                        let obj = {
                            index: newArray.length,
                            name: item.name,
                            status: item.status || 'ACTIVE',
                            uuid: item.uuid,
                            account_no: '',
                            loan_uuid: ''
                        }
                        newArray.push(obj)
                    }
                })
            }

            // Safely process loans
            if (this.loans && Array.isArray(this.loans)) {
                this.loans.forEach(function (item) {
                    // Check if item and item.customer exist and have required properties
                    if (item && item.customer && item.customer.name && 
                        item.customer.name.length > 5 && item.customer.name !== '') {
                        if (!item.customer.name.includes(item.account_no)) {
                            let newobj = {
                                name: item.customer.name,
                                status: item.customer.status || 'ACTIVE',
                                uuid: item.customer_uuid,
                                account_no: item.account_no,
                                loan_uuid: item.uuid
                            }
                            console.log(newobj)
                            newArray.push(newobj)
                        }
                    }
                })
            }
            
            return newArray.sort((a, b) => a.name - b.name);
        },
        sorted_customer_loan_list() {
            return this.customer_loan_list.sort((a, b) => a.account_no - b.account_no);
        }
    },
    methods: {
      removeAllFiles() {
            this.$refs.myVueDropzone.removeAllFiles();
        },
        trigger_event() {
            if (this.$refs.myVueDropzone.getQueuedFiles().length > 0) {
                this.$vs.loading()
                this.$refs.myVueDropzone.processQueue();
            }
        },
        sendingEvent(file, xhr, formData) {
            console.log(file, xhr, formData);
            let uuid = this.backup_loan_uuid
            formData.append("loan_uuid", uuid);
            formData.append("loan_picture", file);
        },
        afterComplete() {
            console.log('afterComplete')
            this.$refs.myVueDropzone.removeAllFiles();
            this.picture_list = []
            this.load_image(this.backup_loan_uuid)
        },
        //image function
        view_image(image_url) {
            let self = this
            this.viewed_image_url = image_url
            self.flag_showImage = true
        },
        load_image(loan_id) {
            console.log('load_image', loan_id)
            if (!loan_id) return false
            let self = this
            const baseURI = 'pictures/list'
            let formData = new FormData();
            formData.append('loan_uuid', loan_id);
            self.picture_list = []
            self.$http.post(baseURI, formData)
                .then((result) => {
                    if (result.data.status == 'success') {
                        console.log('load_image', result.data.data)
                        self.picture_list = result.data.data
                        self.$vs.loading.close()
                    }
                })
        },
        delete_image(img_id, index) {
            let self = this
            var a = confirm('Delete this?')
            if (a) {
                this.$vs.loading()
                const baseURI = 'pictures/' + img_id
                self.$http.delete(baseURI)
                    .then((result) => {
                        if (result.data.status == 'success') {
                            this.$vs.notify({
                                color: 'success',
                                title: 'Image Removed',
                                text: 'The selected attachment was successfully removed'
                            })
                            self.picture_list.splice(index, 1)
                            this.$vs.loading.close()
                        }
                    })
            }
        },
        hasPermission(permissionCode) {
            return this.permissions.includes('*') || this.permissions.includes(permissionCode);
        },
        chooseItem(item) {
            this.listSelect = item
        },
        showThis(item) {
            this.selected_loan_uuid = item.uuid
        },
        refreshlist() {
            this.load_customer_loan_account(this.customer_uuid)
        },
        refreshLoan(event) {
            console.log('event', event)
            this.load_customer_loan_account(this.customer_uuid)
            this.selected_loan_uuid = event
        },
        selectThis(uuid) {
            this.selected_loan_uuid = uuid
        },
        gotoLoan(action, type) {
            let self = this
            //action: previous / next
            //type: number / alphabet
            let filter_arr = this.displayList.filter(item => {
                return item.uuid == self.selected_loan_uuid
            })

            let filter_arr_index = this.displayList.findIndex(item => {
                return item.uuid == self.selected_loan_uuid
            })

            let current_acc_no = ''
            if (filter_arr.length > 0) {
                current_acc_no = filter_arr[0].account_no
            }

            console.log(current_acc_no, action, type)

            if (current_acc_no == '') {
                alert('No account found')
            } else {
                if (type == 'alphabet') {
                    console.log('filter_arr_index', filter_arr_index)
                    if (action == 'previous') {
                        filter_arr_index = filter_arr_index + 1
                        if (filter_arr_index >= this.displayList.length) {
                            filter_arr_index = 0
                        }
                        this.selected_loan_uuid = this.displayList[filter_arr_index].uuid
                    } else {
                        filter_arr_index = filter_arr_index - 1
                        if (filter_arr_index < 0) {
                            filter_arr_index = this.displayList.length - 1
                        }
                        this.selected_loan_uuid = this.displayList[filter_arr_index].uuid
                    }

                    const highlightItem = document.getElementById('id_' + this.displayList[filter_arr_index].account_no);
                    highlightItem.scrollIntoView();
                } else if (type == 'number') {
                    let temp = (current_acc_no.slice(3)).substring(0, 4)
                    let number_arr = Array.from(new Set(this.sorted_customer_loan_list.map((item) => (item.account_no.slice(3)).substring(0, 4))));
                    let current_index = number_arr.indexOf(temp)
                    console.log(number_arr)
                    let tobe_index = ''
                    if (action == 'next') {
                        console.log('next , ', current_index)
                        if (current_index < number_arr.length - 1) tobe_index = current_index + 1
                        else tobe_index = 0
                    } else if (action == 'previous') {
                        console.log('previous , ', current_index)
                        if (current_index <= 0) tobe_index = number_arr.length - 1
                        else tobe_index = current_index - 1
                    }
                    console.log('tobe index', tobe_index)
                    let flagShow = ''
                    this.sorted_customer_loan_list.forEach(function (item, index) {
                        if (item.account_no.includes(number_arr[tobe_index]) && flagShow == '') {
                            flagShow = index
                        }
                    })
                    this.selected_loan_uuid = this.sorted_customer_loan_list[flagShow].uuid
                }
            }
        },
        gotoCustomer(userId) {
            this.$router.push({
                path: `/customer/list/${userId}`
            })
        },
        load_customer_loan_account(cus_id) {
            // if(cus_id == '')
            // return
            let self = this
            self.customer_loan_list = []
            self.flag_loading = true
            self.$vs.loading()
            const baseURI = 'loans/list'
            let formData = new FormData();
            formData.append('customer_uuid', cus_id);
            self.$http.post(baseURI, formData)
                .then((result) => {
                    if (result.data.status == 'success') {
                        self.customer_loan_list = result.data.data
                        self.flag_loading = false

                        self.$vs.loading.close()
                    }
                }).catch(err => {
                    if (err.logout) {
                        self.$vs.loading.close()
                        self.$vs.notify({
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger',
                            title: err.msg
                        })
                        sessionStorage.removeItem('accessToken')
                        sessionStorage.removeItem('user')
                        self.$router.push('/pages/login').catch(() => {})
                    }
                })
        },
        load_customer_contact() {
            let self = this
            const baseURI = 'customers/' + this.customer_uuid
            self.contact_lists = []
            self.$http.get(baseURI)
                .then((result) => {
                    if (result.data.status == 'success') {
                        console.log(result.data.data)
                        let customer_basic = result.data.data
                        let temp = {
                            name: customer_basic.name,
                            contact_no: customer_basic.contact,
                            address: customer_basic.address,
                            remark: customer_basic.remark,
                            uuid: customer_basic.uuid,
                            clickable: true
                        }
                        console.log('customer_basic.dependents', customer_basic.dependents)
                        if (customer_basic.dependents !== '') {
                            self.contact_lists = JSON.parse(customer_basic.dependents)
                            self.contact_lists.unshift(temp)
                        } else {
                            self.contact_lists.push(temp)
                        }
                    }
                })
        },
        load_detail(loan_id) {
            let self = this
            const baseURI = 'loans/' + loan_id
            self.$vs.loading()
            self.$http.get(baseURI)
                .then((result) => {
                    self.$vs.loading.close()
                    console.log('result', result)
                    if (result.data.status == 'success') {
                        self.customer_uuid = result.data.data.customer_uuid
                        setTimeout(function () {
                            self.selected_loan_uuid = result.data.data.uuid
                        }, 500)
                    }
                }).catch(err => {
                    if (err.logout) {
                        self.$vs.loading.close()
                        self.$vs.notify({
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger',
                            title: err.msg
                        })
                        sessionStorage.removeItem('accessToken')
                        sessionStorage.removeItem('user')
                        self.$router.push('/pages/login').catch(() => {})
                    }
                    console.error(err, 'customerManagement/fetchCustomers')
                })
        }
    },
    mounted() {
        let self = this
        var d = document.getElementById("Loan");
        if (d && d.className) {
            d.className += " h-nav-active-item text-primary font-medium";
        }

        if (this.$route.params.loan_id && this.$route.params.loan_id == 'new') {
            this.selectThis('new')
        } else {
            this.backup_loan_uuid = this.$route.params.loan_id
            this.load_detail(this.$route.params.loan_id)
            this.load_image(this.$route.params.loan_id)
        }

        // let newArray = []
        // setTimeout(() => {
        //   self.customers.forEach(function(item){
        //     if(item.name.length > 5 && item.name !== '' ){
        //       let obj = {
        //         name: item.name,
        //         status: item.status,
        //         uuid: item.uuid
        //       }
        //       newArray.push(obj)
        //     }
        //   })

        //   self.loans.forEach(function(item){
        //     if(item.customer.name.length > 5 && item.customer.name !== '' ){
        //       let obj = {
        //         name: item.customer.name,
        //         status: item.customer.status,
        //         uuid: item.customer_uuid
        //       }
        //       newArray.push(obj)
        //     }
        //   })

        //   self.abcList = newArray
        //   console.log(self.abcList.length)
        // }, 2000);
    }
}
</script>

<style lang="scss">
[dir] .vs-collapse-item--header {
    background: lightgray;
    cursor: pointer;
}

.vs-collapse-item {
    cursor: auto;
}

.longlist {
    max-height: 600px;
    overflow-y: scroll;
    border: 1px solid gray;
}

.shortlist {
    max-height: 300px;
    overflow-y: scroll;
    border: 1px solid gray;
}

.disableform {
    pointer-events: none;
    opacity: 0.4;
}

[dir] .vx-card {
    &.contact {
        min-width: 250px;
        min-height: 180px;
        box-shadow: 0px 4px 25px 0px #7B7B7B
    }
}

[dir] .dropzone {
    padding: 10px
}

.margintop {
    position: relative;
    top: -6px;
}

.img-detail .vs-popup--content {
    text-align: center;
}

.install-term .vx-card__header {
    border: 1px solid grey;
    border-bottom: none;
}

.install-term .vx-card__body {
    border: 1px solid grey;
    border-top: none;
    border-bottom: none;
}

.install-term .vx-card__footer {
    border: 1px solid grey;
    border-top: none;
}

.install-term .paid .vx-card__title h4,
.span-PAID {
    color: #00AF2F;
    font-weight: bolder;
}

.span-ONGOING {
    &.latedate {
        animation-name: example;
        animation-duration: 2s;
        animation-iteration-count: infinite;
    }
}

.install-term .latedate .vx-card__title h4 {
    animation-name: example;
    animation-duration: 2s;
    animation-iteration-count: infinite;
}

.inputcss input {
    border: 1px solid #4892CB !important;
}

.arrows {
    display: inline-flex;
    position: relative;
    top: 1.45rem;
}

@keyframes example {
    from {
        color: #FF8C74;
    }

    to {
        color: red;
    }
}

.attachments .vx-card__collapsible-content .vx-card__body {
    padding: .2rem;
}

.con-content--item {
    overflow-x: auto;
}

.vs-textarea:disabled {
    border: 1px solid rgba(0, 0, 0, 0.2);
    opacity: .5;
    cursor: default;
    pointer-events: none;
    background-color: -internal-light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3));
}

.install-term {
    .vx-card .vx-card__collapsible-content .vx-card__body {
        padding: 1rem !important;
        padding-bottom: 1px !important;
    }
}

.vs-collapse-item--content {
    border-top: none;
    padding: 0 !important;
}

.table-full-detail thead tr {
    th {
        font-size: 1rem;
    }

}

.hover-new:hover,
.show-new {
    background: grey;
    color: white;
}

.hover-warning:hover,
.show-warning {
    background: orange;
    color: white;
}

.hover-success:hover,
.show-success {
    background: green;
    color: white;
}

.user-loan,
.detail-loan {
    opacity: 0.5;
}

.user-loan:hover {
    background: #94E0FF;
    color: black;
}

.detail-loan:hover {
    background: #d9fcfd;
    color: black;
}

.show-detail-active {
    opacity: 1;
    background: #d9fcfd;
    color: black;
}

.show-active {
    opacity: 1;
    background: #94E0FF;
    color: black;
}

.image-container {
    max-width: 15rem;
}

@media (max-width: 768px) {
    .image-container {
        width: 100%;
        max-width: 100%;
    }
}
</style>
